import * as ids from '../layerIdStrings';

export const markerIconDefaultColor = {
    'search-result': '#00b3b3',
    'dialekt_record_place': '#57aa27',
    //'dialekt_examples': '#cccc00',
    'dialekt_examples': '#EDE218',
    'dialekt_record_old': '#808080',
    'dialekt_record_new': '#EE82EE',
    'dialekt_record_cja': '#FFA500',
    //'dialekt_record_place_all': '#275ad0',
    'dialekt_record_place_all': '#3A6ED6',
    //'dialekt_speaker_place_all': '#c02028',
    'dialekt_speaker_place_all': '#CE091C',
    'cja_place': '#ff5e5e',
    'oral_speaker_place': '#B3E24D',
    'oral_examples': '#37EFCB',
    'ortofon_speaker_place': '#8E6CF4',
    'ortofon_examples': '#16B9F9',
};

const WEIGHT = 2;
const FILL_OPACITY = 0;
const dialects = JSON.parse(document.getElementById("appContainer").dataset.dialects);

export const overlayStyle = {
    'cr_hranice': (_) => {
        return {
            color: '#000',
            weight: WEIGHT,
            fillOpacity: FILL_OPACITY,
        };
    },
    'cr_kraje': (_) => {
        return {
            color: '#805500',
            weight: WEIGHT,
            fillOpacity: FILL_OPACITY,
        };
    },
    'cr_okresy': (_) => {
        return {
            color: '#e6b800',
            weight: WEIGHT,
            fillOpacity: FILL_OPACITY,
        };
    },
    [ids.CR_OBLASTI]: (feature) => {
        return {
            color: '#888888',
            fillColor: dialects[feature.properties['id']].color,
            //fillOpacity: 0.5,
            weight: WEIGHT,
        };
    },
    [ids.CR_JEMNEJSI]: (feature) => {
        return {
            color: '#888888',
            fillColor: dialects[feature.properties['id']].color,
            //fillOpacity: 0.5,
            weight: WEIGHT,
        };
    },
    'cr_ceska-zemska-hranice': (_) => {
        return {
            color: '#550455',
            weight: 2.5,
        };
    },
    'cr_moravska-zemska-hranice': (_) => {
        return {
            color: '#550455',
            weight: 2.5,
        };
    },
    'cr_njo': (_) => {
        return {
            color: '#555',
            weight: WEIGHT,
        };
    },
    'obec': (_) => {
        return {
            color: '#222',
            fillOpacity: FILL_OPACITY,
            weight: 3,
            opacity: 0.5,
        };
    },
};

export const searchConfig = {
    language: 'cs',
    placeholder: 'Obec, část obce, číslo v ČJA',
};
